import { render } from "./UserAccount.vue?vue&type=template&id=a67b6de6&scoped=true&ts=true"
import script from "./UserAccount.vue?vue&type=script&lang=ts"
export * from "./UserAccount.vue?vue&type=script&lang=ts"

import "./UserAccount.vue?vue&type=style&index=0&id=a67b6de6&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a67b6de6"]])

export default __exports__